import DATATABLE_TRANSLATIONS from "./datatable_translations";

export default class ResidentStatusesDataTable {
  constructor() {
    $(document).ready(function() {
      showResidentStatusesTable();
    });

    $(document).on("turbo:render", function() {
      showResidentStatusesTable();
    });

    function showResidentStatusesTable() {
      $('#resident-statuses-datatable').dataTable({
        "order": [[ 0, "asc" ]],
        "columnDefs": [ {
          "targets"  : 'no-sort',
          "orderable": false,
        }],
        "language": DATATABLE_TRANSLATIONS,
        "processing": true,
        "serverSide": true,
        "ajax": {
          "url": $('#resident-statuses-datatable').data('source')
        },
        "pagingType": "full_numbers",
        "columns": [
          {"data": "name"},
          {"data": "actions"}
        ]
        // pagingType is optional, if you want full pagination controls.
        // Check dataTables documentation to learn more about
        // available options.
      });
    }
  }
}
